/* eslint-disable no-console */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  FormContext,
  FormContextProvider,
  FormSchemaFields,
} from "@sw-sw/lib-form";
import { TooltipContextProvider } from "@sw-sw/lib-ui";
import { toInteger, transform } from "lodash";
import momentTz from "moment-timezone";
import { array, bool, func, number, shape, string } from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../../contexts/AppContext";
import AppDivisionContext from "../../../contexts/AppDivisionContext";
import { useStates } from "../../../hooks/address";
import { useCountries } from "../../../hooks/address";
import { useDivisionClients } from "../../../hooks/client";
import divisionApi from "../../../utils/api/division";
import rolesApi from "../../../utils/api/roles";
import uploadApi from "../../../utils/api/upload";
import FormModal from "../../Shared/form/modal/FormModal";
import Loading from "../../Shared/ResourceIndex/Loading";
import {
  getSchemaLeft,
  getSchemaRight,
} from "./projectFormSchema";
import { env } from '../../../config';
import clientApi from "../../../utils/api/client";
import ProjectContext from "../../../contexts/ProjectContext";
import projectApi from "../../../utils/api/project";
import { UIControlType } from "@sw-sw/lib-form-control-types";
import TenantFeatureContext from "../../../contexts/TenantContext";

/**
 * UI to edit the next inspection date
 * naming convention: variable name "states" refers to -- 
 * 1. states of US (for US region)
 * 2. countries of UK (for UK region) 
 */
function ProjectFormUI({
  schemaData,
  handleSubmit,
  handleClose,
  disableClient,
  appDivisionId,
  projectId,
  ...props
}) {
  const formContext = useContext(FormContext);
  const appContext = useContext(AppContext);
  const projectContext = useContext(ProjectContext);
  const featureContext = useContext(TenantFeatureContext);
  const [clientBasedDocTypes, setClientBasedDocTypes] = useState([])
  const [divisionInspectionIntervals, setDivisionInspectionIntervals] = useState([])
  const [docTypeGroups, setDocTypeGroups] = useState([])
  const [docTypeGroupDisabled, setDocTypeGroupDisabled] = useState(false)

  function submit() {
    // clean values
    const { docTypes = {}, routine_interval, ...values } = formContext.value;

    const selectedDocTypeGroup =  docTypeGroups.filter((ele) => ele.id===Number(formContext.value.project_document_group)).map((ele) => ele.client_group_items).flat()

    //set default doc types in project form
    const defaultDocTypeGroupItems = selectedDocTypeGroup.filter(
      (folder) => ['Fixed Details', 'Fixed Details Project', 'Active Site Maps'].includes(folder.doc_type?.name))

      const defaultDocTypeObj= defaultDocTypeGroupItems.reduce((acc, doc) => {
        acc[doc.doc_type.id] = true;
        return acc;
      }, {});

    Object.assign(docTypes, defaultDocTypeObj);

    const relevantDoctypes = Object.keys(docTypes)
      .reduce((obj, key) => {
        return Object.assign(obj, {
          [key]: docTypes[key]
        });
      }, {});

    // removing the user data to make the payload size less  
    values.client && values.client.map((ele) => {
      delete ele.users

      return ele
    })

    return handleSubmit({
      ...values,
      routine_interval: Number(routine_interval),
      doc_type_group_id: Number(formContext.value.project_document_group),
      // transform docTypes to array
      docTypes: transform(
        relevantDoctypes,
        (acc, val, key) => {
          if (val) acc.push(toInteger(key));
        },
        [],
      ),
    });
  }

  const formData = formContext.value;
  const formSectionProps = {
    formData,
    onChange: formContext.set,
  };
  const clientData = (formData.client && formData.client.length > 0) ? formData.client[0] : false;

  // Helper function to filter and process document types
  const processDocumentGroup = (selectedGroup) => {
    if (!selectedGroup) return;

    const EXCLUDED_DOC_TYPES = ['Fixed Details Project', 'Fixed Details', 'Active Site Maps'];
    
    const filteredClientDocType = selectedGroup.client_group_items.filter(
      (item) => !EXCLUDED_DOC_TYPES.includes(item.doc_type.name) && item.is_checked
    );

    setClientBasedDocTypes(
      filteredClientDocType.map((docTypeItem) => docTypeItem.doc_type)
    );

    const docTypesMap = filteredClientDocType.reduce((acc, doc) => {
      acc[doc.doc_type.id] = true;
      return acc;
    }, {});

    formContext.set('docTypes', docTypesMap);
  };

  useEffect(() => {
    const fetchDocumentGroups = async () => {
      if (!formContext.value.clientId) {
        setDocTypeGroups([]);
        setClientBasedDocTypes([]);
        return;
      }

      try {
        const docTypeGroupsArr = await clientApi.documentGroups.index(formContext.value.clientId);
        setDocTypeGroups(docTypeGroupsArr);

        // Check for locked document group
        const lockedGroup = docTypeGroupsArr.find(group => group.locked_doc_type_group_id);
        
        if (lockedGroup) {
          formContext.set("project_document_group", lockedGroup.id);
          processDocumentGroup(lockedGroup);
          setDocTypeGroupDisabled(true);
          return;
        }

        // No locked group - handle normal selection
        setDocTypeGroupDisabled(false);

        if (formContext.value.project_document_group) {
          const selectedGroup = docTypeGroupsArr.find(
            group => group.id === Number.parseInt(formContext.value.project_document_group)
          );
          processDocumentGroup(selectedGroup);
        } else {
          setClientBasedDocTypes([]);
        }
      } catch (error) {
        console.error('Error fetching document groups:', error);
        setDocTypeGroups([]);
        setClientBasedDocTypes([]);
      }
    };

    fetchDocumentGroups();
    props.getSelectedValue(formContext.value.clientId);
  }, [formContext.value.clientId, formContext.value.project_document_group])

  useEffect(() => {
    const fetchIntervalsAndUpdateIntervalId = async() => {
      let data = await divisionApi.inspectionIntervals.fetchWithDefaultTrue(appDivisionId)

      if(data.length !== 1){
        data = data.filter(ele => ele.default === false)
      }

      if(data.length === 1 && projectId){
        let defaultIntervalId = data[0].id

        let currentIntervalId = projectContext.project.inspection_interval_id

        if(defaultIntervalId !== currentIntervalId){
          await projectApi.updateInspectionIntervalId(projectId, defaultIntervalId)
        }
      }
  
      setDivisionInspectionIntervals(data)
    }

    fetchIntervalsAndUpdateIntervalId()
    
  },[appDivisionId])

  useEffect(() => {

    if(
       !String(formContext.value.longitude).split('').includes('.')){
      if(!isNaN(formContext.value.longitude)){
        formContext.set("longitude" , -Math.abs(formContext.value.longitude))
      }
      if(formContext.value.longitude === ''){
        formContext.set("longitude", '')
      }
    }


  }, [formContext.value.longitude])

  // Clear inspectionTemplateId and precipitation fields when EVP is toggled ON
  useEffect(() => {
    if (formContext.value.external_project) {
      // Fields to clear when EVP is enabled
      const fieldsToClear = ['inspectionTemplateId'];

      // Clear field values
      fieldsToClear.forEach((field) => {
        if (
          formContext.value[field] !== undefined &&
          formContext.value[field] !== null
        ) {
          formContext.set(field, null);
        }
      });

      // Clear any validation errors for these fields
      if (!formContext.isValid) {
        formContext.setIsValid(true, fieldsToClear[0]);
      }
    }
  }, [formContext.value.external_project])

  return (
    <FormModal
      onSubmit={submit}
      onCancel={handleClose}
      modalProps={{
        hideHeader: true,
        classes: "project-form-modal",
        isSmall: false,
        isWide: true,
        style: {},
      }}
    >
      <section className="project-form">
        
        <section className="container create-project-label">
          <label>{(formContext.initialValue && formContext.initialValue.name)? 'Update' : 'Create New'} Project</label>
        </section>

        <section className="container">
          <FormSchemaFields
            {...formSectionProps}
            schema={{
              external_project: {
                label: "EVP : ",
                controlType: UIControlType.toggleButton,
                checked: false,
                toggleSize: 'sm',
                className:'EVP', 
                disabled: !featureContext.tenantHasFeature('External Verification Projects'),
                style: {
                  display: featureContext.tenantHasFeature('External Verification Projects') ? 'flex' : 'none'
                } 
              }
            }}
          />
        </section>

      </section>
      
      <section className="project-form">
        <section className="container">
          <FormSchemaFields
            {...formSectionProps}
            schema={getSchemaLeft(
              schemaData.clients,
              schemaData.inspectionTemplates,
              schemaData.states,
              schemaData.users,
              schemaData.projectTypes,
              schemaData.tz,
              disableClient,
              formData.inspectionTemplateId,
              formData.inspection_compliance_required,
              appContext.get("constants.optionalComplianceTemplates"),
              appContext.get("constants.ccrTemplates"),
              clientData,
              formData.precipitation_edit_lock,
              formData.external_project,
              featureContext.tenantHasFeature('Precipitation Tracking')
            )}
          />
        </section>

        <section className="container">
          <FormSchemaFields
            {...formSectionProps}
            schema={getSchemaRight(clientBasedDocTypes, schemaData.docGroups, divisionInspectionIntervals, docTypeGroups, docTypeGroupDisabled)}
          />
        </section>

        {
          (!featureContext.tenantHasFeature('Precipitation Tracking') ||
          (clientData &&
            !clientData.precipitation_client_project_flag)) &&
          <section className="container precipitation-error-msg-wrapper">
            <p>“Precipitation Tracking has been turned off, to access please contact your company's administrator.”</p>
          </section>
        }

      </section>
    </FormModal>
  );
}

function ProjectForm({ initialData, ...props }) {
  const appContext = useContext(AppContext);
  const { appDivisionId } = useContext(AppDivisionContext);
  const projectContext = useContext(ProjectContext);

  // form data
  const clientsQuery = useDivisionClients(appDivisionId);
  const statesQuery = env.REACT_APP_REGION === "UK" ? useCountries() : useStates();
  const [docGroups, setDocGroups] = useState([]);
  const [users, setUsers] = useState([]);

  const [tz] = useState(appContext.get("constants.tz"));
  const [inspectionTemplates, setTemplates] = useState([]);

  // form states
  const [loaded, setLoadedState] = useState(false);
  const [clientId, setClientId] = useState()
  const [projectTypes, setProjectTypes] = useState()

  function getSelectedValue(value) {
    setClientId(value)
  }

  const projectId = projectContext.project && projectContext.project.id


  useEffect(() => {
    Promise.all([
      divisionApi.regulations.index(appDivisionId),
      divisionApi.inspectionTemplates.index(appDivisionId),
      rolesApi.inspectorRole(appDivisionId),
      projectApi.getProjectTypes()
    ])
      .then(([ docGroupsRes, inspTemplRes, usersRes, projectTypes]) => {
        setDocGroups(docGroupsRes);
        setTemplates(inspTemplRes);
        setUsers(
          usersRes.data.map(user =>
            user.user,
          ),
        );
        setProjectTypes(projectTypes)
        if (
          initialData &&
          initialData.template &&
          inspectionTemplates.filter(({ id }) => id === initialData.template.id)
            .length === 0
        ) {
          setTemplates([initialData.template, ...inspectionTemplates]);
        }

        setLoadedState(true);
      })
      .catch(e => {
        console.log("Error: mounting", e);
      });
  }, []);

  // wait for data to load
  if (!loaded || clientsQuery.isLoading || statesQuery.isLoading) {
    return <Loading />;
  }

  const timezone = momentTz.tz.guess(true);

  return (
    <FormContextProvider
      initialValue={{
        ...initialData,
        clientId: clientId ? clientId : initialData.clientId,
        timezone: env.REACT_APP_REGION === "UK" ? "GMT" :
          (initialData.timezone && tz.includes(initialData.timezone)
            ? initialData.timezone
            : tz.includes(timezone)
              ? timezone
              : tz[0])
      }}
    >
      <TooltipContextProvider>
        <ProjectFormUI
          {...props}
          schemaData={{
            states: statesQuery.data,
            clients: clientsQuery.data,
            docGroups,
            inspectionTemplates,
            users,
            projectTypes,
            tz,
          }}
          getSelectedValue={getSelectedValue}
          appDivisionId={appDivisionId}
          projectId={projectId}
        />
      </TooltipContextProvider>
    </FormContextProvider>
  );
}

const addressObject = {
  street_1: string,
  street_2: string,
  city: string,
  zip: string,
  latitude: string,
  longitude: string,
  state: shape({ id: number, abbreviation: string }),
};

const projectProp = {
  client_id: number,
  address: shape(addressObject),
  start_date: string,
  end_date: string,
  inspection_template_id: number, // ie Inspection Form Type
  findingComplianceRequired: bool,
  permittee: string,
  name: string,
  notes: string,
  routine_interval: number,
  document_group: number, // ie Regulation
};

const schemaDataProp = {
  states: array.isRequired,
  clients: array.isRequired,
  docGroups: array.isRequired,
  inspectionTemplates: array.isRequired,
  users: array.isRequired,
  tz: array.isRequired,
};

ProjectFormUI.propTypes = {
  schemaData: shape(schemaDataProp).isRequired,
  handleClose: func.isRequired,
  handleSubmit: func.isRequired,
  disableClient: bool,
};

ProjectForm.propTypes = {
  handleClose: func.isRequired,
  handleSubmit: func.isRequired,
  submitBtnText: string.isRequired,

  initialData: shape(projectProp),
  disableClient: bool,
};

ProjectForm.defaultProps = {
  initialData: {
    inspection_compliance_required: true,
    findingComplianceRequired: true,
  },
};

export default ProjectForm;
